import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AccountComponent } from './account.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { ProfileComponent } from './profile/profile.component';

const accountRoutes: Routes = [
	{
		path: '',
		component: AccountComponent,
		data: {
			title: '',
		},
		children: [
			{
				path: '',
				component: ProfileComponent,
				pathMatch: 'prefix',
				data: {
					title: 'My Account',
				},
			},
			{
				path: 'reset/password',
				component: ChangePasswordComponent,
				pathMatch: 'prefix',
				data: {
					title: 'Reset Password',
				},
			},
		],
	},
];

@NgModule({
	imports: [RouterModule.forChild(accountRoutes)],
	exports: [RouterModule],
})
export class AccountRoutingModule {}
